const apikey = 'ca2133be25e24abd98e72818210504'
const newskey = '88fbfc3f61e14300888e7ec864828fef'
module.exports = {
  apikey,
  newskey,
}
